/** @format */
import React, { useEffect, useState } from 'react';
import { useStylesPreview } from './style';
import { DatePicker } from 'components/LegacyPickers';
import {
    Grid,
    FormControlLabel,
    RadioGroup,
    Radio,
    Typography
} from '@mui/material';
import clsx from 'clsx';
import jMoment from 'moment-jalaali';
import {
    InputV2,
    SelectV,
    DatePickerPod,
    InputCurrency,
} from 'components';
import { useFormContext } from 'react-hook-form';
const profileInvoice = ({ voucherType, setVoucherType, totalPrice }) => {
    const methods = useFormContext();
    const classes = useStylesPreview();
    const toolsPay = [{ value: 'PAYMENT_TOOL_CHEQUE', label: 'چک' },]  // ابزار پرداخت 
    const [valueAmount, setValueAmount] = useState('');  // مبلغ و درصد قابل پرداخت  
    const disableStyle = {
        backgroundColor: 'rgb(222 222 222 / 32%)',
        cursor: 'not-allowed',
        color: 'rgb(163 163 163)',
        borderRadius: 8
    };

    // شرط انتخاب درصدی و مبلغی بودن مقدار
    useEffect(() => {
        if (voucherType === 'percentage') {
            setValueAmount('100')

        } else {
            setValueAmount(totalPrice)
        }
    }, [voucherType, totalPrice]);

    //اعتبار سنجی فیلد های پروفایل
    useEffect(() => {
        methods.register('payDueDate');
        methods.setValue('payDueDate', jMoment())
        return () => {
            methods.unregister('payDueDate');
        };
    }, [methods.register, methods.unregister]);

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            item
            className={classes.root}
            xs={12}
        >
            <Grid item xs={12} >
                <Grid container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    item>
                    <Grid item lg={3} md={3} xs={12}>
                        <SelectV
                            label="انتخاب ابزار پرداخت"
                            name="toolType"
                            options={toolsPay}
                            control={methods.control}
                            register={methods.register}
                            errors={methods.formState.errors}
                            style={disableStyle}
                            rules={['required']}
                            fullWidth
                            disabled={true}
                            margin="dense"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} >
                    <RadioGroup
                        row
                        xs={12}
                        required
                        onChange={(e) => {
                            setVoucherType(e?.target?.value);
                        }}
                        value={voucherType}
                        className={classes.options}
                        defaultValue={voucherType}
                        style={{ marginBottom: 30 }}
                    >
                        <Grid container xs={12} lg={3} md={3} justifyContent="flex-start" className={classes.radioItemBlock}>
                            <FormControlLabel
                                value="amount"
                                className={clsx(classes.radioItem, {
                                    active: voucherType === 'amount',
                                })}
                                control={<Radio style={{ display: 'none' }} />}
                                label={
                                    <Typography
                                        className={clsx(classes.radioText, {
                                            active: voucherType === 'amount',
                                        })}
                                    >
                                        مبلغ ثابت
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                value="percentage"
                                className={clsx(classes.radioItem, {
                                    active: voucherType === 'percentage',
                                })}
                                control={<Radio style={{ display: 'none' }} />}
                                label={
                                    <Typography
                                        className={clsx(classes.radioText, {
                                            active: voucherType === 'percentage',
                                        })}
                                    >
                                        درصد فاکتور
                                    </Typography>
                                }
                            />
                        </Grid>
                    </RadioGroup>
                </Grid>
                <Grid container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    item>
                    <Grid item xs={12} lg={3} md={3}>
                        <DatePickerPod label="تاریخ سررسید پرداخت" showAsterisk >
                            <DatePicker
                                variant="inline"
                                name="payDueDate"
                                autoOk
                                inputVariant="outlined"
                                showTodayButton
                                todayLabel="امروز"
                                disabled
                                okLabel="تایید"
                                cancelLabel="لغو"
                                clearLabel="پاک کردن"
                                labelFunc={(date) => (date ? jMoment(date).format('jYYYY/jMM/jDD') : '')}
                                value={methods.watch('payDueDate')}
                                onChange={(e) => methods.setValue('payDueDate', e)}
                                minDate={jMoment()}
                                style={{ marginBottom: '8px' }}
                                rules={['required']}

                            />
                        </DatePickerPod>

                    </Grid>
                    <Grid item lg={3} xs={12} >
                        <InputV2
                            fullWidth
                            errors={methods.formState.errors}
                            label="پرداخت کننده (تلفن همراه/کد ملی)"
                            name="payerId"
                            register={methods.register}
                            rules={['required', 'isNumeric']}
                            dir='ltr'
                        />
                    </Grid>
                </Grid>
                <Grid container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    item>
                    <Grid item lg={3} md={3} xs={12}>
                        <InputCurrency
                            fullWidth
                            errors={methods.formState.errors}
                            currency
                            label="مبلغ کل فاکتور"
                            name="totalPrice"
                            register={methods.register}
                            disabled={true}
                            control={methods.control}
                            style={disableStyle}
                            forceValue={totalPrice} 
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        {voucherType === 'amount' ? (
                            <InputCurrency
                                fullWidth
                                errors={methods.formState.errors}
                                currency
                                label="مبلغ قابل پرداخت با ابزار"
                                disabled={true}
                                name="amount"
                                register={methods.register}
                                control={methods.control}
                                style={disableStyle}
                                forceValue={Number(valueAmount)}

                            />
                        ) : (
                            <InputV2
                                fullWidth
                                errors={methods.formState.errors}
                                currency
                                label="درصد قابل پرداخت با  ابزار"
                                minimumValue="0"
                                disabled={true}
                                currencyText="درصد"
                                style={disableStyle}
                                name="amountPercentage"
                                register={methods.register}
                                control={methods.control}
                                forceValue={Number(valueAmount)}
                            />
                        )}

                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    );
};

export default profileInvoice;
